import { render, staticRenderFns } from "./EnvelopeModal.vue?vue&type=template&id=7763b866&"
import script from "./EnvelopeModal.vue?vue&type=script&lang=js&"
export * from "./EnvelopeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports